@if (!isSuspendedBillingOnly()) {
  <app-pan-action-bar class="mb-4">
    <ol class="inline-flex items-center space-x-1 md:space-x-2">
      <li>
        <a panButton color="info" (click)="uploadShrinkCSV.click()"> Upload Shrink </a>

        <input type="file" class="hidden" accept=".csv" #uploadShrinkCSV (change)="uploadShrinkCSVToServer($event.target)" />
      </li>
    </ol>
  </app-pan-action-bar>
}

<div>
  <ag-grid-angular
    #branchesGrid
    [rowData]="branches()"
    [columnDefs]="branchColumns"
    [gridOptions]="tableDef"
    [loading]="isLoading()"
    class="w-full"
  ></ag-grid-angular>
</div>

<app-pan-modal #createNewBranch id="createNewBranch" [topLevel]="false" data-testid="create-branch-modal">
  <div header>Create New Branch</div>

  <div body class="flex flex-col gap-2">
    <app-pan-form-control>
      <app-pan-floating-label>Branch Name</app-pan-floating-label>
      <input type="text" panInput [(ngModel)]="newBranchName" placeholder="Enter branch name..." data-testid="create-branch-name-input" />
    </app-pan-form-control>

    <app-pan-form-control>
      <app-pan-floating-label>Business Vertical</app-pan-floating-label>
      <ng-select
        data-testid="bl-business-vertical-select"
        appendTo="body"
        placeholder="Select business vertical..."
        [bindValue]="'id'"
        [bindLabel]="'name'"
        [virtualScroll]="true"
        [appendTo]="'body'"
        [items]="verticals()"
        [(ngModel)]="newBranchVertical"
      >
      </ng-select>
    </app-pan-form-control>

    <app-pan-form-control>
      <app-pan-floating-label>Customer Type</app-pan-floating-label>
      <ng-select
        data-testid="bl-customer-type-select"
        appendTo="body"
        placeholder="Select customer type..."
        [bindValue]="'id'"
        [bindLabel]="'name'"
        [virtualScroll]="true"
        [appendTo]="'body'"
        [items]="customerTypes()"
        [(ngModel)]="newBranchCustomerType"
      >
      </ng-select>
    </app-pan-form-control>
  </div>

  <div footer class="flex gap-2">
    <button panButton panModalClose data-testid="create-branch-cancel">Cancel</button>
    <button panButton color="primary" (click)="createBranch()" [disabled]="!canCreateBranch()" data-testid="create-branch-submit">
      Create Branch
    </button>
  </div>
</app-pan-modal>
